import GeolocateSVG from '../../assets/svg/geolocate.svg';
export default GeolocateSVG;
